import { saveAs } from 'file-saver';
import { Download, X } from 'lucide-react';
import type { PipelineMetrics } from '../lib/types';

interface Props {
  metrics: PipelineMetrics | null;
  svg: string | null;
  isProcessing: boolean;
  onClear: () => void;
}

export function StickyBar({ metrics, svg, isProcessing, onClear }: Props) {
  return (
    <div className="sticky bottom-0 z-10 flex items-center justify-between border-t border-[var(--border)] bg-[var(--theme)] px-4 py-3">
      <div className="font-mono text-xs tracking-wide text-[var(--secondary)]">
        {metrics
          ? `${metrics.inputWidth}×${metrics.inputHeight} ${metrics.inputMime} · ${fmt(metrics.inputBytes)} → ${fmt(metrics.outputBytes)} · ${metrics.pathCount} paths · ${metrics.durationMs} ms`
          : 'Drop an image to begin.'}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onClear}
          className="flex items-center gap-1.5 rounded border border-[var(--border)] px-3 py-2 text-sm text-[var(--primary)] transition hover:bg-[var(--entry)]"
        >
          <X className="h-4 w-4" /> Clear
        </button>
        <button
          disabled={!svg || isProcessing}
          onClick={() => svg && saveAs(new Blob([svg], { type: 'image/svg+xml' }), 'vektor.svg')}
          className="flex items-center gap-2 rounded bg-[var(--content)] px-4 py-2 text-sm font-medium text-[var(--content-fg)] shadow-[0_6px_18px_-4px_rgba(234,88,22,.40)] transition hover:brightness-105 disabled:opacity-40 disabled:shadow-none"
        >
          <Download className="h-4 w-4" /> Download SVG
        </button>
      </div>
    </div>
  );
}

function fmt(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
